import { Form, Space, Switch, TableColumnType } from "antd";
import React from "react";
import { Dimen } from "../../../models/dimen";
import { Checks } from "../../../models/setting";
import styles from './invent.module.css'

// 盘点记录查询
export const InventoryRecordsColumns = (
  startIndex: number,
  KFGZZCKLRSJData?: any,
  settings?: any,
): TableColumnType<any>[] => {

  // 新老目录展示方式 (老目录没有区分药品类别/无型号)
  const getProcuctInfo = (item: any) => {
    const materialsCategory = item.materialsCategory
    const packSpec = item.packSpec ? item.packSpec : '-'
    const spec = item.spec ? item.spec : '-'
    const doseCategory = item.doseCategory ? item.doseCategory : '-'
    const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'
    const model = item.model ? '/' + item.model : ''

    if (settings?.[Checks.MLKG] == 1) {
      if (materialsCategory == '0') {
        //  生产厂家 + 包装规格 + 剂型 
        return tenantSupplierName + '/' + packSpec + '/' + doseCategory
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 生产厂家 + 包装规格 +  型号 
        return tenantSupplierName + '/' + packSpec + model
      } else {
        // 生产厂家 + 包装规格 
        return tenantSupplierName + '/' + packSpec
      }
    } else {
      if (materialsCategory == '0') {
        // 生产厂家 + 包装规格 + 剂型 
        return tenantSupplierName + '/' + packSpec + '/' + doseCategory
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 生产厂家 + 规格 +  型号 
        return tenantSupplierName + '/' + spec + model
      } else {
        // 生产厂家 + 规格 
        return tenantSupplierName + '/' + spec
      }
    }
  }

  return [
    {
      title: "序号",
      align: "center",
      key: "no",
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "商品编码",
      align: "center",
      dataIndex: "no",
      width: Dimen.Coding,
      key: "no",
    },
    {
      title: "产品信息",
      align: "left",
      dataIndex: "producInfo",
      key: "producInfo",
      render: function Element(_, record) {
        return (
          <div style={{ height: "55px" }}>
            <p
              className={styles.nameText}
            >
              {record.name}
            </p>
            <p
              className={styles.productText}
            >
              {getProcuctInfo(record)}
            </p>
          </div>
        );
      },
    },

    {
      title: "账簿数量",
      align: "center",
      dataIndex: "count",
      key: "count",
      render: (_: any, t: any) => {
        return t.realCount - t.count < -1 ? "-" : t.realCount - t.count;
      },
    },
    {
      title: "实际数量",
      align: "center",
      dataIndex: "realCount",
      key: "realCount",
    },
    {
      title: "盘盈盘亏数",
      align: "center",
      dataIndex: "count",
      key: "count",
      render: (_: any, t: any) => {
        return t.count ? parseFloat((t.count as unknown) as string) : 0;
      },
    },

    {
      title: "账簿数量(拆零)",
      align: "center",
      dataIndex: "",
      key: "",
      render: (_: any, t: any) => {
        return t.count
          ? parseFloat(((t.realSplitCount - t.splitCount) as unknown) as string)
          : 0;
      },
    },
    {
      title: "实际数量（拆零）",
      align: "center",
      dataIndex: "",
      key: "",
      render: (_: any, t: any) => {
        return t.realSplitCount
          ? parseFloat((t.realSplitCount as unknown) as string)
          : 0;
      },
    },
    {
      title: "盘盈盘亏（拆零）",
      align: "center",
      dataIndex: "",
      key: "",
      render: (_: any, t: any) => {
        return t.splitCount
          ? parseFloat((t.splitCount as unknown) as string)
          : 0;
      },
    },
    {
      title: "进价",
      align: "right",
      dataIndex: "",
      key: "",
      render: (_: any, t: any) => {
        return !KFGZZCKLRSJData ? '***' : (t.unitPrice
          ? parseFloat((t.unitPrice as unknown) as string).toFixed(5)
          : 0);
      },
    },
    {
      title: "变动金额(进价)",
      align: "right",
      dataIndex: "changeUnitPrice",
      key: "changeUnitPrice",
      render: (_: any, t: any) => {
        return !KFGZZCKLRSJData ? '***' : (t.changeUnitPrice
          ? parseFloat(((t.changeUnitPrice) as unknown) as string).toFixed(
              2
            )
          : "");
      },
    },

    {
      title: "盘点时间",
      align: "center",
      dataIndex: "upAccountTime",
      key: "upAccountTime",
    },
  ];
};
